var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.warehouse-articles'),"text":_vm.$t('warehouse_articles.description'),"name":"warehouseArticles","url":_vm.$listRoutes.warehouseArticles,"table":_vm.warehouseArticles,"filters":_vm.warehouseArticlesFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }